
  import {Component, Vue} from "vue-property-decorator";
  import VendorService from "../../services/vendor.service";
  import AuthService from "../../services/auth.service";
  import CreateNewVendorEntryDialog from './CreateNewVendorEntryDialog.vue';
  import LoadingOverlay from "../core/LoadingOverlay.vue";

  @Component({
    components: {CreateNewVendorEntryDialog, LoadingOverlay}
  })
  export default class VendorManagement extends Vue {

    tableData: any[] = [];

    createNewVendorEntryDialogVisible = false;

    selectedVendorForEdit: any = "";

    private showOverlay = false;

    private vendorNameFilterValue = "";
    private vendorNumberAimsFilterValue = "";
    private stadtFilterValue = "";
    private plzFilterValue = "";
    private ibanFilterValue = "";

    private isMohtamimMuhasibUser: boolean = false;
    private isMoawinMuhasibUser: boolean = false;
    private isMohtamimMaalUser: boolean = false;


    headers = [
      {text: 'Vendor-Nr Aims', value: 'aimsId', filter: this.vendorNumberAimsFilter},
      {text: 'Vendor-Name', value: 'name', filter: this.vendorNameFilter},
      {text: 'PLZ', value: 'postcode', filter: this.plzFilter},
      {text: 'Stadt', value: 'city', filter: this.stadtFilter},
      {text: 'IBAN', value: 'bankAccounts[0].iban', filter: this.ibanFilter},
      {text: 'Erstellt von', value: 'createdBy'},
      {text: 'Bearbeiten', value: 'edit', sortable: false, filterable: false, align: 'center'},
    ];


    beforeMount() {
      this.loadVendors();
    }

    created() {
      let userRoles = AuthService.getRoles();

      if (userRoles.indexOf("ROLE_MOHTAMIM_MUHASIB") >= 0) {
        this.isMohtamimMuhasibUser = true;
      }
      if (userRoles.indexOf("ROLE_MOAWIN_MUHASIB") >= 0) {
        this.isMoawinMuhasibUser = true;
      }
      if (userRoles.indexOf("ROLE_MOHTAMIM_MAAL") >= 0) {
        this.isMohtamimMaalUser = true;
      }
    }

    loadVendors() {
      this.showOverlay = true;
      VendorService.getAllVendors()
        .then(
          (response: any) => {
            this.tableData = response.data;
            this.showOverlay = false;
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

    showNewVendorEntryDialog() {
      this.selectedVendorForEdit = null;
      this.createNewVendorEntryDialogVisible = true;
    }

    handleEdit(selectedVendor: any) {
      this.selectedVendorForEdit = Object.assign({}, selectedVendor)
      this.createNewVendorEntryDialogVisible = true;
    }

    vendorNameFilter(valueInRow: any) {
      if (!this.vendorNameFilterValue) {
        return true;
      }
      return (valueInRow.toUpperCase().indexOf(this.vendorNameFilterValue.toUpperCase()) >= 0);
    }

    vendorNumberAimsFilter(valueInRow: any) {
      if (!this.vendorNumberAimsFilterValue) {
        return true;
      }
      return (valueInRow.toString().toUpperCase().indexOf(this.vendorNumberAimsFilterValue.toString().toUpperCase()) >= 0);
    }

    stadtFilter(valueInRow: any) {
      if (!this.stadtFilterValue) {
        return true;
      }
      if (valueInRow)
        return (valueInRow.toUpperCase().indexOf(this.stadtFilterValue.toUpperCase()) >= 0);
    }


    plzFilter(valueInRow: any) {
      if (!this.plzFilterValue) {
        return true;
      }
      if (valueInRow)
        return (valueInRow.toString().toUpperCase().indexOf(this.plzFilterValue.toString().toUpperCase()) >= 0);
    }

    ibanFilter(valueInRow: any) {
      if (!this.ibanFilterValue) {
        return true;
      }
      if (valueInRow)
        return (valueInRow.toUpperCase().indexOf(this.ibanFilterValue.toUpperCase()) >= 0);
    }

    handleCloseNewVendorEntry(){
      this.createNewVendorEntryDialogVisible = false;
      this.loadVendors();
    }

  }
